document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.spec-card').forEach(function(card){

        card.addEventListener('mouseenter',function(){

            this.style.transform='translateY(-3px)';

        });

        card.addEventListener('mouseleave',function(){

            this.style.transform='translateY(0)';

        });

    });

});